var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'circle-icon circle-icon--' + _vm.styleModifier},[_c('div',{staticClass:"circle-icon__icon",on:{"click":_vm.emitClickEvent}},[_vm._t("icon")],2),_c('div',{staticClass:"circle-icon__caption",on:{"click":_vm.emitClickEvent}},[_c('span',[_vm._v(_vm._s(_vm.caption))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }